import Gifting from '@/routes/web/Gifting';
import AuthMiddleware from '@/middleware/AuthMiddleware';

export default [
    {
        path: '/account',
        name: 'account',
        beforeEnter: AuthMiddleware,
        redirect: { name: 'account.dashboard' },
        components: {
            // route level code-splitting. This generates a separate chunk (account.[hash].js) for this route which is
            // lazy-loaded when the route is visited.
            default: () => import(/* webpackChunkName: "account" */ '@/views/Account.vue'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
            orderSummaryModal: () => import(/* webpackChunkName: "order-modal" */ '@/components/modals/shop/OrderSummaryModal'),
        },
        children: [
            {
                path: 'confirmation',
                name: 'account.confirmation',
                component: () => import(/* webpackChunkName: "account" */ '@/views/account/Confirmation'),
            },
            {
                path: 'account-confirmation',
                name: 'account.account-confirmation',
                component: () => import(/* webpackChunkName: "account" */ '@/views/account/AccountConfirmation'),
            },
            {
                path: 'dashboard',
                name: 'account.dashboard',
                component: () => import(/* webpackChunkName: "account" */ '@/views/account/Dashboard.vue'),
                meta: {
                    navigation: {
                        // title: '<span>My</span> Dashboard',
                    },
                },
            },
            {
                path: 'outstanding-orders',
                name: 'account.outstanding-orders',
                component: () => import(/* webpackChunkName: "account" */ '@/views/account/OutstandingOrders'),
            },
            {
                path: 'rate-my-flowers',
                name: 'account.rate-my-flowers',
                component: () => import(/* webpackChunkName: "account" */ '@/views/account/RateMyFlowers.vue'),
                meta: {
                    navigation: {
                        // title: 'Rate Flowers',
                    },
                },
            },
            {
                path: 'free-flowers',
                name: 'account.free-flowers',
                component: () => import(/* webpackChunkName: "account" */ '@/views/account/FreeFlowers.vue'),
                meta: {
                    navigation: {
                        // title: 'Send a friend free flowers',
                    },
                },
            },
            {
                path: 'your-boxes/:scheduleDate/:subscriptionId',
                name: 'account.your-boxes.redirect',
                component: () => import(/* webpackChunkName: "account" */ '@/views/account/YourBoxes.vue'),
                meta: {
                    navigation: {
                        // title: 'Your Boxes',
                    },
                },
            },
            {
                path: 'your-boxes',
                name: 'account.your-boxes',
                component: () => import(/* webpackChunkName: "account" */ '@/views/account/YourBoxes.vue'),
                meta: {
                    navigation: {
                        // title: 'Your Boxes',
                    },
                },
            },
            {
                path: 'delivery-schedule',
                name: 'account.delivery-schedule',
                component: () => import(/* webpackChunkName: "account" */ '@/views/account/MyDeliverySchedule.vue'),
                meta: {
                    navigation: {
                        // title: '<span>MY</span> Delivery Schedule',
                    },
                },
            },
            {
                path: 'pause',
                name: 'account.pause-account',
                component: () => import(/* webpackChunkName: "account" */ '@/views/account/Pause.vue'),
                meta: {
                    navigation: {
                        title: '',
                    },
                },
            },
            {
                path: 'pause-or-cancel',
                name: 'account.pause-or-cancel',
                component: () => import(/* webpackChunkName: "account" */ '@/views/account/PauseOrCancel.vue'),
                meta: {
                    navigation: {
                        title: '',
                    },
                },
            },
            {
                path: 'update-your-plan',
                name: 'account.update-your-plan',
                component: () => import(/* webpackChunkName: "account" */ '@/components/partials/account/my-delivery-schedule/UpdateYourPlan.vue'),
                meta: {
                    navigation: {
                        title: 'Update Plan',
                    },
                },
            },
            {
                path: 'order-a-vase',
                name: 'account.order-a-vase',
                component: () => import(/* webpackChunkName: "account" */ '@/views/account/OrderVase.vue'),
                meta: {
                    navigation: {
                        // title: 'Order a Vase',
                    },
                },
            },
            {
                path: 'shop',
                name: 'account.shop',
                component: () => import(/* webpackChunkName: "account" */ '@/views/account/Shop.vue'),
                meta: {
                    navigation: {
                        // title: 'Shop',
                    },
                },
            },
            {
                path: 'shop/:productId',
                name: 'account.shop.product',
                component: () => import(/* webpackChunkName: "account" */ '@/views/account/ShopProductDetails.vue'),
                meta: {
                    navigation: {
                        // title: 'Shop',
                    },
                },
            },
            {
                path: 'addresses',
                name: 'account.delivery-addresses',
                component: () => import(/* webpackChunkName: "account" */ '@/views/account/MyDeliveryAddresses.vue'),
                meta: {
                    navigation: {
                        // title: 'Delivery addresses',
                    },
                },
            },
            {
                path: 'next-week-delivery',
                name: 'account.next-week-delivery',
                component: () => import(/* webpackChunkName: "account" */ '@/views/account/NextWeekDelivery.vue'),
                meta: {
                    navigation: {
                        // title: 'Next Delivery',
                    },
                },
            },
            {
                path: 'card-details',
                name: 'account.card-details',
                component: () => import(/* webpackChunkName: "account" */ '@/views/account/CardDetails.vue'),
                meta: {
                    navigation: {
                        // title: 'Card Details',
                    },
                },
            },
            {
                path: 'manage-account',
                name: 'account.manage-account',
                component: () => import(/* webpackChunkName: "account" */ '@/views/account/ManageAccount.vue'),
                meta: {
                    navigation: {
                        // title: 'Manage Account',
                    },
                },
            },
            {
                path: 'gifting',
                name: 'account.gifting',
                redirect: { name: 'account.gifting.choose-your-gift' },
                component: () => import(/* webpackChunkName: "account" */ '@/views/account/Gifting.vue'),
                children: Gifting,
                meta: {
                    navigation: {
                        // title: 'Gifting',
                    },
                },
            },
            {
                path: 'restart-confirmation-page',
                name: 'account.restart-confirmation-page',
                component: () => import(/* webpackChunkName: "account" */ '@/views/account/RestartConfirmationPage.vue'),
            },
            {
                path: 'gifting-reminders',
                name: 'account.gifting-reminders',
                component: () => import(/* webpackChunkName: "account" */ '@/views/account/GiftingReminders.vue'),
                meta: {
                    navigation: {
                        title: 'Gifting Reminders',
                    },
                },
            },
            {
                path: 'bumper-box',
                name: 'account.bumper-box',
                component: () => import(/* webpackChunkName: "account" */ '@/views/account/BumperBox.vue'),
                meta: {
                    navigation: {
                        // title: 'Bumper Box',
                    },
                },
            },
        ],
    },
];
